var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"internal-ata-deneme"}},[_c('apexchart',{attrs:{"type":"bar","width":"100%","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }